export const telephoneRegex = [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const cellphoneRegex = [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const internationalOnlyNumbersRegex = Array(24).fill(/\d/);
export const cpfRegex = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];
export const cnpjRegex = [
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '.',
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '.',
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '/',
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  '-',
  /\d/,
  /\d/,
];
export const stateInscriptionRegex = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
];
const zeroWidthSpaceRegex = /[\u00AD\u200B-\u200D\uFEFF]/g;
export const cepRegex = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
export const zipCodeRegex = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

export const telephoneOrCellphoneRegex = (value: string): (string | RegExp)[] => {
  const withoutMask = value && value.length > 0 ? value.replace(/\D/g, '') : '';

  if (withoutMask.length <= 10) {
    return telephoneRegex;
  }

  return cellphoneRegex;
};

export const uuidRegex =
  /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;

export const inputCodeWithoutZeroWidthSpace = (codeOrBarcodeOrName: string) =>
  codeOrBarcodeOrName.replace(zeroWidthSpaceRegex, '').trim();
